<template>
  <section>
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="10000"
      multi-line
      left
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>

    <!-- DIALOGS START -->
    <v-dialog v-model="dialog.loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.delete"
      max-width="500"
      persistent
      v-if="dialog.hasLoaded && (!dfns.isPast(event.startDate))"
    >
      <v-card>
        <v-card-title class="headline">You Sure, about deleting this Event?</v-card-title>

        <v-card-text>Are you sure, you want to delete this event?
          <br>We suggest verifying the details before taking such an action.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            flat="flat"
            @click="() => { this.dialog.delete = false; this.$router.push(`/evoting/event/${event.id}`) }"
          >Don't Delete</v-btn>

          <v-btn color="error" flat="flat" @click="deleteEvent">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.update"
      max-width="500"
      persistent
      v-if="dialog.hasLoaded"
    >
      <v-card>
        <v-card-title class="headline">Update this Event!</v-card-title>

        <v-card-text>
          <v-form v-model="valid">
            <div>
              <v-text-field label="NAME" :rules="rules.name" v-model="form.name"/>
              <datetime type="datetime" v-model="form.startDate">
                <label for="startDate" slot="before">Start Date: </label>
                <template slot="button-cancel">
                  <v-icon>fas fa-times</v-icon>
                  Cancel
                </template>
                <template slot="button-confirm">
                  <v-icon>fas fa-check-circle</v-icon>
                  Confirm
                </template>
              </datetime>
              <br>
              <datetime type="datetime" v-model="form.endDate" :min-datetime="form.startDate">
                <label for="endDate" slot="before">End Date: </label>
                <template slot="button-cancel">
                  <v-icon>fas fa-times</v-icon>
                  Cancel
                </template>
                <template slot="button-confirm">
                  <v-icon>fas fa-check-circle</v-icon>
                  Confirm
                </template>
              </datetime>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error"
            flat="flat"
            @click="() => { this.dialog.update = false; this.$router.push(`/evoting/event/${event.id}`) }"
          >Don't Update</v-btn>
          <v-btn color="success" flat="flat" :disabled="!valid || !dfns.isValid(new Date(form.startDate)) || !dfns.isValid(new Date(form.endDate)) || dfns.isAfter(new Date(form.startDate), new Date(form.endDate))" @click="updateEvent">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.voter" max-width="500" persistent v-if="dialog.hasLoaded">
      <v-card>
        <v-card-title class="headline">Update this Voter!</v-card-title>

        <v-card-text>
          <v-form>
            <div>
              <v-text-field label="NAME" :rules="rules.name" v-model="voterForm.name"/>
            </div>
            <div>
              <v-text-field label="EMAIL" :rules="rules.email" v-model="voterForm.email"/>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="success" flat="flat" @click="dialog.voter = false;">Don't Update</v-btn>

          <v-btn color="error" flat="flat" @click="updateVoter(dialog.voterId)">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddVoters
      @update="
    () => {
      getVoters($route.params.id);
      snackbar = {
        show: true,
        text: `The Voters have been created!`,
        color: `success`
      }; 
    }
    "
      @fail="
    (error) => {
      snackbar = {
        show: true,
        text: (error.graphQLErrors || []).length > 0
            ? error.graphQLErrors[0].data
              ? error.graphQLErrors[0].data.message
              : error.graphQLErrors[0].message
            : error.message || 'An internal error has occured.',
        color: 'error'
      }
    }
    "
      v-if="dialog.hasLoaded && dialog.addVoters"
      :event="event"
      v-model="dialog.addVoters"
    />

    <!-- DIALOGS END -->
    <v-container grid-list-md v-if="dialog.hasLoaded && !error">
      <v-layout row wrap>
        <v-flex sm12 md12 lg6>
          <v-card class="con--view-card">
            <div class="con--view-grid-basic">
              <div class="con--view-grid-basic-span-col-2">
                <div class="con--view-card-inner">
                  <p class="con--view-card-title" style="text-transform: capitalize;"><strong>{{event.name}}</strong></p>
                  <p class="con--view-card-subtitle"><strong>ID# </strong>{{event.id}}</p>
                  <p class="con--view-card-subtitle"><strong>Entity: </strong>
                    <router-link :to="`/evoting/entity/${event.entity.id}`">{{event.entity.name}}</router-link>
                  </p>
                  <p class="con--view-card-subtitle"><strong>Start Date:</strong> {{format(event.startDate)}}</p>
                  <p class="con--view-card-subtitle"><strong>End Date:</strong> {{format(event.endDate)}}</p>
                  <p class="con--view-card-subtitle">
                    <strong>Event Type: </strong> {{ event.eventType }}
                  </p>
                  <p class="con--view-card-subtitle">
                    <strong>Status:</strong>
                    {{
                    dfns.isPast(event.startDate) ? (dfns.isPast(event.endDate) ? "Ended" : "On Going") : "Hasn't Started."
                    }}
                  </p>
                </div>
              </div>
            </div>
          </v-card>
        </v-flex>
        <v-flex sm12 md12 lg6>
          <v-card class="con--view-card">
            <p class="con--view-title">Actions</p>
            <v-btn
              color="orange"
              @click="moveTo(`/evoting/event/${event.id}?update=1`)"
            >Update</v-btn>
            <v-btn
              color="error"
              :disabled="dfns.isPast(event.startDate)"
              @click="moveTo(`/evoting/event/${event.id}?delete=1`)"
            >Delete</v-btn>
            <v-btn
              color="success"
              :disabled="dfns.isPast(event.startDate)"
              @click="dialog.addVoters = true;"
              v-if="voters.length < 1"
            >Add Voters</v-btn>
            <v-btn
              color="blue"
              dark
              @click="downloadLinks"
              v-if="voters.length != 0 && dfns.isPast(event.startDate)"
            >Download Links</v-btn>
            <v-btn color="grey" dark @click="downloadResult">Download Results</v-btn>
          </v-card>
        </v-flex>
        <v-flex sm12 md12 lg12>
          <v-card class="con--view-card">
            <p class="con--view-title">Agendas</p>
            <v-spacer/>
            <v-tabs dark show-arrows>
              <v-tabs-slider color="yellow"></v-tabs-slider>

              <v-tab v-for="(i, idx) in event.agendas" :key="i.id">Agenda {{ idx + 1 }}</v-tab>

              <v-tabs-items>
                <v-tab-item v-for="(i,idx) in event.agendas" :key="i.id">
                  <v-card flat>
                    <v-card-text
                      v-if="i.name.indexOf('=html%') !== -1"
                      v-html="i.name.replace('=html%', '')"
                    ></v-card-text>
                    <v-card-text v-else>{{i.name}}</v-card-text>
                    <v-card-text>
                      <h2 v-if="event.eventType !== 'choice'">Threshold: {{ i.threshold }}%</h2>
                      <h2 v-else>Options: {{ i.options }}</h2>
                    </v-card-text>
                    <!-- Agenda Edit --> 
                    <v-btn @click="toggleAgenda(idx)" color="primary">Toggle Edit Agenda</v-btn>
                    <v-card-text 
                      v-if="
                        event.eventType !== 'choice' &&
                        agendaEdit.idx === idx &&
                        agendaEdit.isEdit === true
                        "
                    >
                      <v-textarea 
                        label="Agenda Name" 
                        v-model="agendaCopy[idx].name" 
                        name="input-7-1"
                        box 
                        :rows="3">
                      </v-textarea>
                      <v-text-field
                        label="Agenda Threshold"
                        v-model="agendaCopy[idx].threshold"
                        outlined
                        min="0"
                        max="100"
                        type="number" 
                      >
                      </v-text-field>
                      <v-btn @click="updateAgenda" color="success" :disabled="agendaCopy[idx].name === '' || agendaCopy[idx].threshold == '' || agendaCopy[idx].threshold < 0 || agendaCopy[idx].threshold > 105">Update Agenda</v-btn>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-card>
        </v-flex>
        <v-flex sm12 md12 lg12>
          <p class="con--view-title">Voters: {{ avoters.total }}</p>
          <v-card class="con--view-card" style="overflow-y: scroll; max-height: 220px;">
            <v-list style="background: inherit;">
              <v-list-tile
                v-for="(voter, idx) in voters"
                :key="voter.id"
                avatar
                class="elevation-2"
                style="margin-bottom: 10px;"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ idx + 1 }}.
                    {{ voter.name }} -
                    {{ voter.email }} -
                    {{ voter.votePower }}% (
                    <span
                      v-if="voter.hasVoted"
                      style="color: green;"
                    >Voted</span>
                    <span v-else style="color: red;">Not Voted</span>
                    )
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <div>
                    <v-btn
                      icon
                      ripple
                      style="margin-right: 5px;"
                      @click="updateVoterClick(voter.id)"
                    >
                      <v-icon color="success">fas fa-pen</v-icon>
                    </v-btn>
                  </div>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <div class="text-xs-center" v-if="avoters.pages > 1">
              <v-pagination :length="avoters.pages" :total-visible="8" v-model="paginationOpts.page" :disabled="paginationOpts.disabled" />
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="error">
      <div>
        <v-alert
          :value="error"
          type="error"
        >{{ error.graphQLErrors.length > 0 ? error.graphQLErrors[0].message : error.message }}</v-alert>
      </div>

      <v-flex sm12 md12 lg12>
        <v-card class="con--view-card" style="min-height:150px;">
          <h2
            style="text-align: center;"
          >{{ error.graphQLErrors.length > 0 ? error.graphQLErrors[0].data.message : error.message }}</h2>

          <div style="text-align: center;">
            <v-btn color="primary" to="/evoting/event">Go back</v-btn>
          </div>
        </v-card>
      </v-flex>
    </v-container>
  </section>
</template>
<script>
import { coreClient } from "../../apollo";
import gql from "graphql-tag";
import checkPhone from "validator/lib/isMobilePhone";
import dfns from "date-fns";
import AddVoters from "./components/addVoters";
import generateSnackbarError from "../generateSnackbarError";
import { Datetime } from 'vue-datetime';

export default {
  components: {
    AddVoters,
    Datetime
  },
  data() {
    return {
      event: {
        id: "",
        name: "",
        eventType: "",
        entity: {
          id: "",
          name: ""
        },
        agendas: [],
        startDate: "",
        endDate: ""
      },
      agendaEdit: {
        idx: null,
        isEdit: false 
      },
      agendaCopy: [],
      voterForm: {
        name: "",
        email: ""
      },
      paginationOpts: {
        page: 1,
        limit: 50,
        disabled: false
      },
      voters: [],
      avoters: [],
      voterKV: {}, // voter keyValue
      dialog: {
        update: false,
        delete: false,
        hasLoaded: false,
        loading: false,
        addVoters: false,
        voter: null,
        voterId: ""
      },
      snackbar: {
        show: false,
        text: "",
        color: ""
      },
      error: "",
      valid: false,
      form: {
        name: "",
        startDate: "",
        endDate: ""
      },
      rules: {
        name: [
          v => !!v || "The name is required.",
          v => v.length > 2 || "The name must be greater than 2 characters."
        ],
        email: [
          v => !!v || "The email is required.",
          v =>
            /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
              v
            ) || "Please enter a valid email address."
        ]
      },
      dfns: {
        isPast: dfns.isPast,
        isValid: dfns.isValid,
        isAfter: dfns.isAfter
      }
    };
  },
  methods: {
    toggleAgenda(idx) {
      if (this.agendaEdit.isEdit && this.agendaEdit.idx === idx) {
        this.agendaEdit.isEdit = false;
        this.agendaEdit.idx = null;
      } else {
        this.agendaEdit.isEdit = true;
        this.agendaEdit.idx = idx;
      }
    },
    async downloadResult() {
      try {
        const { data } = await coreClient.query({
            query: gql`
            query getEventResultAdmin($eventId: String!) {
              getEventResultAdmin(eventId: $eventId)
            }
            `,
            variables: {
              eventId: this.event.id
            }
        });
        
        console.log(data);

        let csvData = new Blob([data.getEventResultAdmin], { type: "text/csv;charset=utf-8;" });
        let csvURL = window.URL.createObjectURL(csvData);
        let tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", `Event-${this.event.id}.csv`);
        tempLink.click();

      } catch (e) {
        console.log(e)
        this.snackbar = {
          show: true,
          text: "Failed to download the result.",
          color: "error"
        };
        this.err = e;
      }
    },
    async updateVoter(id) {
      const voter = this.voterKV[id];
      let variables = {};
      Object.keys(this.voterForm).forEach(field => {
        if (voter[field] !== this.voterForm[field]) {
          variables[field] = this.voterForm[field];
        }
      });
      variables.id = id;
      variables.eventId = this.event.id;

      this.snackbar.show = false;

      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation updateVoter(
              $id: String!
              $eventId: String!
              $name: String
              $email: String
            ) {
              updateVoter(
                id: $id
                eventId: $eventId
                name: $name
                email: $email
              ) {
                id
                name
                email
                votePower
                hasVoted
              }
            }
          `,
          variables
        });
        this.snackbar = {
          show: true,
          text: "The Event has been updated successfully.",
          color: "success"
        };

        await this.getVoters(this.event.id);
      } catch (e) {
        this.snackbar = {
          show: true,
          text: "Failed to update the Voter.",
          color: "error"
        };
        this.err = e;
      }
      this.dialog.voter = null;
    },
    updateVoterClick(id) {
      this.dialog.voter = true;
      this.dialog.voterId = id;
      this.voterForm = { ...this.voterKV[id] };
    },
    async downloadLinks() {
      const obs = coreClient.watchQuery({
        query: gql`
          query getEventLinks($eventId: String!) {
            getEventLinks(eventId: $eventId)
          }
        `,
        variables: {
          eventId: this.event.id
        },
        fetchPolicy: "cache-and-network"
      });

      obs.subscribe(
        ({ data, loading }) => {
          if (data) {
            // download csv
            let links = data.getEventLinks;
            let csvData = new Blob([links], {
              type: "text/csv;charset=utf-8;"
            });
            let csvURL = window.URL.createObjectURL(csvData);
            let tempLink = document.createElement("a");
            tempLink.href = csvURL;
            tempLink.setAttribute(
              "download",
              `Evoting-Links-${this.event.name}-${this.event.id}.csv`
            );
            tempLink.click();
          }
        },
        err => {
          this.snackbar.show = false;
          this.snackbar = {
            show: true,
            text: generateSnackbarError(err, "Voting Links"),
            color: "error"
          };
          this.error = err;
        }
      );
    },
    async getEvent(id) {
      this.dialog.loading = true;
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Event($id: String!) {
              Event(id: $id) {
                id
                name
                eventType
                entity {
                  id
                  name
                }
                agendas {
                  id
                  name
                  threshold
                  agendaType
                  options
                }
                startDate
                endDate
              }
            }
          `,
          variables: {
            id
          }
        });
        this.event = data.Event;
        this.agendaCopy = JSON.parse(JSON.stringify(data.Event.agendas));
      } catch (e) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "We failed to find the Event.",
          color: "error"
        };
        this.error = e;
      }
      this.dialog.loading = false;
      this.dialog.hasLoaded = true;
    },
    async getVoters(eventId) {
      this.paginationOpts.disabled = true;
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Voters($eventId: String!, $limit: Int, $page: Int) {
              AdminVoters(eventId: $eventId, limit: $limit, page: $page) {
                total
                page
                pages
                docs {
                  id
                  name
                  email
                  votePower
                  hasVoted
                }
              }
            }
          `,
          fetchPolicy: "no-cache",
          variables: { eventId, page: this.paginationOpts.page, limit: this.paginationOpts.limit }
        });
        this.avoters = data.AdminVoters;
        this.voters = data.AdminVoters.docs;
        this.voterKV = {};
        this.voters.forEach(el => {
          this.voterKV[el.id] = el;
        });
      } catch (error) {
        this.snackbar = {
          show: true,
          text:
            (error.graphQLErrors || []).length > 0
              ? error.graphQLErrors[0].data
                ? error.graphQLErrors[0].data.message
                : error.graphQLErrors[0].message
              : error.message || "An internal error has occured.",
          color: "error"
        };
      }
      this.paginationOpts.disabled = false;
    },
    moveTo(u) {
      this.$router.push(u);
      this.$router.go(u);
    },
    format(date) {
      return dfns.format(new Date(date), "DD[/]MM[/]YY HH:mm");
    },
    deleteEvent() {},
    async updateAgenda() {
      const {idx} = this.agendaEdit;
      const updates = this.agendaCopy[idx];
      updates.eventId = this.event.id;
      updates.threshold = parseFloat(updates.threshold);
      try {
        await coreClient.mutate({
          mutation: gql`
            mutation updateAgenda($eventId: String!, $id: String!, $name: String, $threshold: Float) {
              updateAgenda(eventId: $eventId, agendaId: $id, name: $name, threshold: $threshold)
            }
          `,
          variables: updates
        });

        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "The Agenda has been updated successfully.",
          color: "success"
        };

        this.event.agendas[idx] = JSON.parse(JSON.stringify(this.agendaCopy[idx]));
        this.agendaEdit.isEdit = false;
      } catch (error) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text:
            (error.graphQLErrors || []).length > 0
              ? error.graphQLErrors[0].data
                ? error.graphQLErrors[0].data.message
                : error.graphQLErrors[0].message
              : error.message || "An internal error has occured.",
          color: "error"
        };
      }
    },
    async updateEvent() {
      let variables = {};
      Object.keys(this.form).forEach(field => {
        if (this.event[field] !== this.form[field]) {
          variables[field] = this.form[field];
        }
      });

      variables.id = this.event.id;
      console.log(variables)
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation updateEvent($id: String!, $name: String, $startDate: String, $endDate: String) {
              updateEvent(id: $id, name: $name, startDate: $startDate, endDate: $endDate) {
                id
                name
                eventType
                entity {
                  id
                  name
                }
                agendas {
                  id
                  name
                  threshold
                  agendaType
                  options
                }
                startDate
                endDate
              }
            }
          `,
          variables
        });

        this.event = data.updateEvent;
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "The Event has been updated successfully.",
          color: "success"
        };
      } catch (error) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text:
            (error.graphQLErrors || []).length > 0
              ? error.graphQLErrors[0].data
                ? error.graphQLErrors[0].data.message
                : error.graphQLErrors[0].message
              : error.message || "An internal error has occured.",
          color: "error"
        };
      }
      this.dialog.update = false;
    }
  },
  async mounted() {
    let { query } = this.$route;
    await this.getEvent(this.$route.params.id);
    await this.getVoters(this.$route.params.id);

    if (query.update && query.delete) {
      // Uhmm, some error probably.
      return;
    }

    if (query.update) {
      // open the update prompt
      this.dialog.update = true;
      this.form = { ...this.event };
      return;
    }

    if (query.delete) {
      // open the delete prompt.
      this.dialog.delete = true;
      return;
    }

    return;
  },
  watch: {
    'paginationOpts.page'() {
      this.getVoters(this.$route.params.id) 
    }
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/Company_view.styl';
</style>

<style>
.vdatetime-input {
  border: 1px solid black !important;
  margin-left: 5px;
}
</style>
